﻿$.fn.dxCtrlWizardAnimItemType = function custom_dxCtrlWizardAnimItemType(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizardanimitemtype dx-ctrl");
        this.createInstance(new cdxCtrlWizardAnimItemType(this, option));
    }
    return this;
}

window.cdxCtrlWizardAnimItemType = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var isPhone = (parametre.isPhone || option.forcePhone)
    var $TableTitle = null
    var dxScroll = null
    var marginHeight = 100
    function mConstruit() {
        container.empty();
        marginHeight = 100
        container.css({
            width: "calc(100% - 100px)",
            "max-height": "calc(100% - " + marginHeight + "px)",
            "max-width": "750px",
            margin: "50px 50px 50px 5px",
            position: "absolute",
            padding: "30px",
            border: theme.border,
            "border-radius": "5px",
            "background-color": theme.backgroundcolorWizardAnim
        })
        if (option.dxItem.hasHeight100Percent && option.dxItem.hasHeight100Percent()) {
            marginHeight = 100
            container.css({
                "max-height": "",
                "height": "calc(100% - " + marginHeight + "px)"
            })
        }
        if (isPhone) {
            marginHeight = 45
            container.css({
                width: "100%",
                "max-height": "",
                "height": "calc(100% - " + marginHeight + "px)",
                "max-width": "750px",
                margin: "0px 0px 45px 0px",
                position: "absolute",
                padding: "5px 5px 5px 15px",
                border: theme.border,
                "border-radius": "5px",
                "background-color": theme.backgroundcolorWizardAnim
            })
            //container.css({
            //    width: "calc(100% - 5px)",
            //    "max-height": "calc(100% - " + marginHeight + "px)",
            //    "max-width": "750px",
            //    margin: "10px 10px 40px 0px",
            //    position: "absolute",
            //    padding: "5px 5px 5px 15px",
            //    border: theme.border,
            //    "border-radius": "5px",
            //    "background-color": theme.backgroundcolorWizardAnim
            //})
        }

        if (option.dxItem.title && option.dxItem.title() && option.dxItem.afficheTitle && option.dxItem.afficheTitle()) {
            $TableTitle = $("<table style='width:100%;font-size:160%;padding-bottom:5px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($TableTitle)
            var $Td = $("<td style='width:0px;font-size:34px;line-height:1;' class='dx-theme-accent-as-text-color'></td>").appendTo($Tr)
            var $Td = $("<td style='width:100%;padding-left:5px;line-height:1;vertical-align:middle;font-weight:bold;'>" + option.dxItem.title() + "</td>").appendTo($Tr)
        }

        dxScroll = $("<div/>").appendTo(container).dxScrollView({
            showScrollbar: "always"
        }).dxScrollView("instance")
        dxScroll.content().css("padding-right", "2px")

        option.dxItem.element().appendTo(dxScroll.content())
        option.dxItem.option("onNext", function () {
            if (option.onNext) option.onNext()
        })
        option.dxItem.option("onPrevious", function () {
            if (option.onPrevious) option.onPrevious()
        })

        var timeoutResize = null
        window.setTimeout(function () {
            resizeObserver.mAdd([container, option.dxItem.element()], function () {
                window.clearTimeout(timeoutResize)
                timeoutResize = window.setTimeout(function () { Me.mResize() }, 0)
            })()
        }, 0)

        //$(window).resize(function () {
        //    Me.mResize()
        //});
        //Me.mResize()
    }

    this.mResize = function () {
        //dxScroll.element().css("height", "")
        //dxScroll.element().css("height", (container.innerHeight() - ($TableTitle ? $TableTitle.innerHeight() : 0) - 100) + "px")
        var savedScrollTop = dxScroll.scrollOffset().top
        dxScroll.element().css("height", "")
        if (dxScroll.content().innerHeight() + ($TableTitle ? $TableTitle.innerHeight() : 0) > container.innerHeight() - marginHeight - (isPhone ? 0 : -25)) {
            //dxScroll.element().css("height", (container.innerHeight() - ($TableTitle ? $TableTitle.innerHeight() : 0) - marginHeight) + "px")
            dxScroll.element().css("height", (container.innerHeight() - marginHeight - (isPhone ? 0 : -25)) + "px")
        }
        dxScroll.update()
        if (savedScrollTop > 0) {
            dxScroll.scrollTo({ top: savedScrollTop })
        }
    }

    this.title = function () {
        return (option.dxItem.title ? option.dxItem.title() : "")
    }

    this.afficheTitle = function () {
        return (option.dxItem.afficheTitle ? option.dxItem.afficheTitle() : false)
    }

    this.isOkForNext = function () {
        return option.dxItem.isOkForNext(dxScroll)
    }

    this.mGetProprieteImage = function () {
        return (option.dxItem.mGetProprieteImage ? option.dxItem.mGetProprieteImage() : null)
    }

    this.mIsActivated = function () {
        if (option.dxItem.mIsActivated) option.dxItem.mIsActivated()
    }

    this.mGetUrlLink = function () {
        return option.dxItem.mGetUrlLink()
    }

    this.mGetIndexFromUrlLink = function (locationPathname) {
        return option.dxItem.mGetIndexFromUrlLink(locationPathname)
    }

    this.mGetClassIconeForLstItem = function () {
        return (option.dxItem.mGetClassIconeForLstItem ? option.dxItem.mGetClassIconeForLstItem() : null)
    }

    this.btPreviousVisible = function () {
        return (option.dxItem.btPreviousVisible ? option.dxItem.btPreviousVisible() : true)
    }
    this.btNextVisible = function () {
        return (option.dxItem.btNextVisible ? option.dxItem.btNextVisible() : true)
    }

    this.element = function () { return container; }

    mConstruit();
}